export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
            <path
                d="M42.5972 38.7364C43.4308 36.7272 43.8912 34.527 43.8912 32.2207V13.0726L26.3954 7.4375L8.90096 13.0726V32.2207C8.78884 47.0784 27.1459 54.9098 38.0742 45.0506"
                stroke="black"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M31.2537 20.1978C28.4278 17.3564 24.1853 16.8129 20.814 18.5623L24.3727 22.1404L20.518 26.016L16.9594 22.4379C15.2194 25.8264 15.7612 30.0932 18.5859 32.9345C21.2424 35.6043 25.1496 36.2426 28.4087 34.8568L39.6456 46.1561C40.9595 47.4771 43.0897 47.4759 44.4036 46.1561C45.7175 44.835 45.7175 42.6932 44.4036 41.3721L33.1667 30.074C34.5439 26.7971 33.9102 22.8687 31.2537 20.1978Z"
                stroke="#F7A40A"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
